import { Link } from "react-router-dom";
import { Linkedin, Twitter, Instagram, MessageCircle, Music2, Youtube } from "lucide-react";
import { BRAND_LABEL, LEGAL_NAME, SOCIAL_PROFILES } from "../config/branding";

const profileUrl = (name) =>
  SOCIAL_PROFILES.find((profile) => profile.name === name).url;

function Footer() {
  return (
    <footer className="border-t border-[#111712]/15 bg-[#eeeee8] px-6 pb-10 pt-16 text-[#111712] md:px-10">
      <div className="max-w-6xl mx-auto grid gap-12 md:grid-cols-3">
        <div>
          <h2 className="font-serif text-3xl font-bold tracking-[-0.04em] text-[#111712]">{BRAND_LABEL}</h2>

          <p className="mt-4 text-[#4d5951]">
            Building intelligent AI systems through {LEGAL_NAME} and empowering
            the next generation of innovators.
          </p>

          <div className="flex flex-wrap gap-4 mt-6">
            <a
              href={profileUrl("LinkedIn")}
              target="_blank"
              rel="me noopener noreferrer"
              className="group"
              aria-label={`${BRAND_LABEL} on LinkedIn`}
            >
              <Linkedin className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>

            <a
              href={profileUrl("X")}
              target="_blank"
              rel="me noopener noreferrer"
              className="group"
              aria-label={`${BRAND_LABEL} on X`}
            >
              <Twitter className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>

            <a
              href={profileUrl("Instagram")}
              target="_blank"
              rel="me noopener noreferrer"
              className="group"
              aria-label={`${BRAND_LABEL} on Instagram`}
            >
              <Instagram className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>

            <a
              href="https://wa.me/254777748910"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
              aria-label={`Chat with ${BRAND_LABEL} on WhatsApp`}
            >
              <MessageCircle className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>

            <a
              href={profileUrl("YouTube")}
              target="_blank"
              rel="me noopener noreferrer"
              className="group"
              aria-label={`${BRAND_LABEL} on YouTube`}
            >
              <Youtube className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>

            <a
              href={profileUrl("TikTok")}
              target="_blank"
              rel="me noopener noreferrer"
              className="group"
              aria-label={`${BRAND_LABEL} on TikTok`}
            >
              <Music2 className="h-5 w-5 text-[#4d5951] transition duration-300 group-hover:scale-110 group-hover:text-[#45695a]" />
            </a>
          </div>
          <Link
            to="/socials"
            className="mt-5 inline-block text-sm text-[#4d5951] underline decoration-[#111712]/25 underline-offset-4 hover:text-[#45695a]"
          >
            View all official {BRAND_LABEL} social media accounts
          </Link>
        </div>

        <div>
          <h3 className="mb-4 font-semibold text-[#45695a]">Quick Links</h3>

          <ul className="space-y-2 text-[#4d5951]">
            <li>
              <Link to="/#about" className="hover:text-[#45695a]">
                About
              </Link>
            </li>
            <li>
              <Link to="/#services" className="hover:text-[#45695a]">
                Services
              </Link>
            </li>
            <li>
              <Link to="/#projects" className="hover:text-[#45695a]">
                Projects
              </Link>
            </li>
            <li>
              <Link to="/#contact" className="hover:text-[#45695a]">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 font-semibold text-[#45695a]">
            Start a Conversation
          </h3>

          <p className="mb-4 text-[#4d5951]">
            Tell us what you are building, teaching, or exploring, and we will
            point you to the right program, service, or next step.
          </p>

          <Link
            to="/#contact"
            className="inline-flex rounded-lg bg-[#d6e85c] px-4 py-2 font-medium text-[#111712] transition hover:bg-[#cce141]"
          >
            Contact {BRAND_LABEL}
          </Link>
        </div>
      </div>

      <div className="mt-12 border-t border-[#111712]/15 pt-6 text-center text-sm text-[#667269]">
        &copy; {new Date().getFullYear()} {LEGAL_NAME}. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
